export default {
    Metadata: {
        Name: "Insert",
        Description: "Returns a string from a base with a given string inserted at the specified position.",
        Syntax: "Insert(base_string, insertPos_number, insert_string)",
        Keywords: ['String', 'Text'],
        Author: "DataVoke, Inc.",
    },
    execute(baseString, intPos, insertString) {
        if (baseString != null && insertString != null) {
            return baseString.substr(0, intPos) + insertString + baseString.substr(intPos, baseString.length - intPos);
        }

        else if (baseString) {
            return baseString;
        }
        else {
            return insertString;
        }
    },
};

